import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import request from './request'
import router from './router'

Vue.use(ElementUI);
Vue.prototype.$axios = request
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')


